import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./component/scrollToTop/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";

// Home Pages Import
import DigitalAgency from "./pages/DigitalAgency";
import CreativeAgency from "./pages/CreativeAgency";
import PersonalPortfolio from "./pages/PersonalPortfolio";
import HomeStartup from "./pages/HomeStartup";
import CorporateAgency from "./pages/CorporateAgency";

// Blog Import
import BlogGridView from "./pages/BlogGrid";
import BlogCategory from "./pages/Category";
import BlogArchive from "./pages/Archive";
import BlogDetails from "./pages/BlogDetails";

// Service
import ServiceOne from "./pages/ServiceOne";
import ServiceTwo from "./pages/ServiceTwo";
import ServiceDetails from "./pages/ServiceDetails";

// Project
import ProjectGridOne from "./pages/ProjectGridOne";
import ProjectGridTwo from "./pages/ProjectGridTwo";
import ProjectGridThree from "./pages/ProjectGridThree";
import ProjectGridFive from "./pages/ProjectGridFive";
import ProjectGridFour from "./pages/ProjectGridFour";
import ProjectDetails from "./pages/ProjectDetails";

// Pages
import Splash from "./pages/Splash";
import AboutUs from "./pages/AboutUs";
import OurOffice from "./pages/OurOffice";
import OurClients from "./pages/OurClients";
import Team from "./pages/Team";
import TeamDetails from "./pages/TeamDetails";
import CaseStudy from "./pages/CaseStudy";
import CaseDetails from "./pages/CaseStudyDetails";
import Testimonials from "./pages/Testimonials";
import PricingTable from "./pages/PricingTable";
import Typography from "./pages/Typography";
import Contact from "./pages/Contact";
import ErrorPage from "./pages/404";
import ComingSoon from "./pages/ComingSoon";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";

// Css Import
import "./assets/scss/app.scss";
import FAQs from "./pages/FAQs";
import IndustriesWeServe from "./pages/IndustriesWeServe";
import ProjectGridOne1 from "./pages/ProjectGridOne1";
import RequestQuote from "./pages/RequestAQuote";
import SupportPage from "./pages/supportPage";
import ClientPortfolio from "./pages/ClientPortfolio";
import industry from "./pages/Industry";
import OurService from "./pages/OurStory";
import OurStory from "./pages/OurStory";
import MissionVision from "./pages/MissionVision";
import Gallery from "./pages/Gallery";
import Certification from "./pages/Certification";
import HealthSafety from "./pages/HealthSafety";
import CafmSoftware from "./pages/CafmSoftware";
import Careers from "./pages/Careers";
import EstimateProject from "./pages/EstimateProject";
import IfmService from "./pages/IfmService";
import AccountSoftware from "./pages/AccountSoftware";
import CAFM from "./pages/CAFM";
import CRM from "./pages/CRM";
import HRM from "./pages/HRM";
import Industry from "./pages/Industry";
import Sustainability from "./pages/Sustainability";
import SmartTech from "./pages/SmartTech";
import MainLayout from "./component/mainlayout/MainLayout";

const App = () => {
  return (
    <Router>
      <ScrollToTop>
        <MainLayout>
          <Routes>
            {/* <Route path={process.env.PUBLIC_URL + "/"} element={<Splash />}/> */}

            {/* Redirect / to /digital-agency */}
            {/* <Route path={process.env.PUBLIC_URL + "/"} element={<Navigate to={process.env.PUBLIC_URL + "/digital-agency"} />} /> */}
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={<DigitalAgency />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/creative-agency"}
              element={<CreativeAgency />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/personal-portfolio"}
              element={<PersonalPortfolio />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/home-startup"}
              element={<HomeStartup />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/corporate-agency"}
              element={<CorporateAgency />}
            />

            {/* Blogs */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-list"}
              element={<BlogGridView />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/category/:slug"}
              element={<BlogCategory />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/archive/:slug"}
              element={<BlogArchive />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-individual/:id"}
              element={<BlogDetails />}
            />

            {/* Service */}
            <Route
              path={process.env.PUBLIC_URL + "/services"}
              element={<ServiceOne />}
            />
            {/* <Route path={process.env.PUBLIC_URL + "/service-two/"} element={<ServiceTwo />}/> */}
            <Route
              path={process.env.PUBLIC_URL + "/service/:slug"}
              element={<ServiceTwo />}
            />
            {/* <Route path={process.env.PUBLIC_URL + "/ifm-service"} element={<IfmService />}/> */}
            <Route
              path={process.env.PUBLIC_URL + "/service/:category/:service"}
              element={<ServiceDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/sustainability"}
              element={<Sustainability />}
            />

            {/* Industry We Serve*/}
            {/* <Route path={process.env.PUBLIC_URL + "/industry/:slug"} element={<IndustriesWeServe />} /> */}

            {/* Client Portfolio*/}
            <Route
              path={process.env.PUBLIC_URL + "/client-portfolio"}
              element={<ClientPortfolio />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/industry"}
              element={<Industry />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/smart-tech"}
              element={<SmartTech />}
            />
            {/* Project  */}
            <Route
              path={process.env.PUBLIC_URL + "/project-grid-one"}
              element={<ProjectGridOne />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-grid-one1"}
              element={<ProjectGridOne1 />}
            />

            <Route
              path={process.env.PUBLIC_URL + "/project-grid-two"}
              element={<ProjectGridTwo />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-grid-three"}
              element={<ProjectGridThree />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-width-one"}
              element={<ProjectGridFour />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-width-two"}
              element={<ProjectGridFive />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/project-details/:slug"}
              element={<ProjectDetails />}
            />

            {/* Pages  */}
            <Route
              path={process.env.PUBLIC_URL + "/technology/hrm"}
              element={<HRM />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/technology/crm"}
              element={<CRM />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/technology/cafm"}
              element={<CAFM />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/technology/accounts-software"}
              element={<AccountSoftware />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/estimate-project"}
              element={<EstimateProject />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/accreditations"}
              element={<Certification />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/gallery"}
              element={<Gallery />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/mission-vision"}
              element={<MissionVision />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/health-safety"}
              element={<HealthSafety />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/cafm-software"}
              element={<CafmSoftware />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/who-we-are"}
              element={<OurStory />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/about-us"}
              element={<AboutUs />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/our-office"}
              element={<OurOffice />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/our-clients"}
              element={<OurClients />}
            />
            <Route path={process.env.PUBLIC_URL + "/team"} element={<Team />} />
            <Route
              path={process.env.PUBLIC_URL + "/team-details/:slug"}
              element={<TeamDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/case-study"}
              element={<CaseStudy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/case-details/:slug"}
              element={<CaseDetails />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/testimonials"}
              element={<Testimonials />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/pricing-table"}
              element={<PricingTable />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/typography"}
              element={<Typography />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact-us"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/careers"}
              element={<Careers />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/request-quote"}
              element={<RequestQuote />}
            />
            <Route path={process.env.PUBLIC_URL + "/faqs"} element={<FAQs />} />
            <Route
              path={process.env.PUBLIC_URL + "/terms-conditions"}
              element={<SupportPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/privacy-policy"}
              element={<SupportPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/cookie-policy"}
              element={<SupportPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/404"}
              element={<ErrorPage />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/coming-soon"}
              element={<ComingSoon />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/privacy-policy"}
              element={<PrivacyPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/terms-use"}
              element={<TermsOfUse />}
            />
          </Routes>
        </MainLayout>
      </ScrollToTop>
    </Router>
  );
};

export default App;
